import type { PagedAndSortedResultRequestDto } from '@abp/ng.core';

export interface ColppyHealthCheckDto {
  winesWithoutIdItem: WineWithoutIdItemDto[];
  winesWithDuplicateIdItem: WineWithDuplicateIdItemDto[];
  pickUpsWithoutColppyWarehouse: PickUpWithoutColppyWarehouseDto[];
  logsSummary: ColppyLogsSummaryDto;
  wineAvailabilityCache: WineAvailabilityCacheDto;
}

export interface ColppyLogDto {
  id: number;
  creationTime?: string;
  entityType?: string;
  entityId?: string;
  entityName?: string;
  externalCode?: string;
  idItemColppy?: string;
  operation?: string;
  logType: number;
  severity: number;
  message?: string;
  details?: string;
  colppyErrorCode?: string;
  colppyErrorMessage?: string;
  colppyResponse?: string;
  stackTrace?: string;
  attemptCount: number;
  isResolved: boolean;
  resolvedAt?: string;
  resolvedBy?: string;
  additionalInfo?: string;
}

export interface ColppyLogsSummaryDto {
  totalLogs: number;
  errorLogs: number;
  warningLogs: number;
  informationLogs: number;
  unresolvedErrors: number;
  winesWithErrors: number;
  pickUpsWithErrors: number;
  recentErrors: RecentErrorDto[];
}

export interface GetColppyLogsDto extends PagedAndSortedResultRequestDto {
  entityType?: string;
  entityId?: string;
  operation?: string;
  logType?: number;
  severity?: number;
  isResolved?: boolean;
  fromDate?: string;
  toDate?: string;
  keyword?: string;
}

export interface ItemAvailabilityDto {
  idItem?: string;
  disponibilidad?: string;
  wineName?: string;
  externalCode?: string;
}

export interface PickUpWithoutColppyWarehouseDto {
  id: number;
  name?: string;
  address?: string;
  email?: string;
  isActive: boolean;
}

export interface RecentErrorDto {
  id: number;
  entityType?: string;
  entityName?: string;
  externalCode?: string;
  operation?: string;
  message?: string;
  attemptCount: number;
  creationTime?: string;
  isResolved: boolean;
}

export interface WarehouseAvailabilityDto {
  warehouseName?: string;
  itemCount: number;
  items: ItemAvailabilityDto[];
}

export interface WineAvailabilityCacheDto {
  isEmpty: boolean;
  totalWarehouses: number;
  totalItems: number;
  warehouses: WarehouseAvailabilityDto[];
}

export interface WineWithDuplicateIdItemDto {
  id: number;
  name?: string;
  description?: string;
  externalCode?: string;
  idItemColppy?: string;
  isActive: boolean;
}

export interface WineWithoutIdItemDto {
  id: number;
  name?: string;
  externalCode?: string;
  isActive: boolean;
}

export interface ColppyPriceListDto {
  id: number;
  company_id: number;
  description?: string;
  default_currency_id: number;
  is_disabled: number;
  iso?: string;
}

export interface ColppyPriceListItemDto {
  id: number;
  codigo?: string;
  descripcion?: string;
  sale_price: number;
  disponibilidad?: number;
}

export interface ColppyProductDto {
  codigo?: string;
  disponibilidad: number;
  nombre?: string;
  precioVenta?: number;
  precioVentaSinIVA?: number;
}

export interface DepositoDisponibilidadDto {
  nombre?: string;
  disponibilidad?: string;
}

export interface ItemAndAvailabilityDto {
  idItem?: string;
  disponibilidad?: string;
}

export interface ProximoNumeroRemitoResponseDto {
  success: boolean;
  proximoNum?: string;
  metodoNum?: string;
}

export interface RemitoItemDto {
  idItem?: string;
  codigo?: string;
  descripcion?: string;
  deposito?: string;
  detalle?: string;
  ccosto1?: string;
  ccosto2?: string;
  unidadMedida?: string;
  cantidad: number;
  importeUnitario?: string;
  minimo?: string;
  tipoItem?: string;
}
